import React from 'react'

import AssetsTable from 'atoms/AssetsTable'

import { CallToActionRow, AccountRow } from 'atoms/AssetsTable'

// this currently uses assetstable, will most likely need to be its own thing depending on how tyler designs this Table

function LifeInsuranceTable() {
  const rows = [
    {
      header: 'My Total Estate',
      headerValue: 1300877,
      expandable: true,
      content: (
        <>
          <CallToActionRow text="Add Annual Leave" />
          <AccountRow name="Net Worth" amount={807292} />
          <AccountRow name="Life Insurance" amount={240000} />
          <AccountRow name="BEDB" amount={214269} />
          <AccountRow
            name="Surviver Benefit Value (present value)"
            amount={110000}
          />
        </>
      ),
    },
    {
      header: '*Estimated Coverage Need',
      headerValue: 1400688,
      //   expandable: true,
      //   content: (
      //     <>
      //       <CallToActionRow text="Add PARCO Income Solution to Bridge Gap" />
      //       <AccountRow name="Account Name" amount={44.09} />
      //       <AccountRow name="Another Account" amount={3333} />
      //     </>
      //   ),
    },
    {
      header: 'L.I. Gap (Estate - *Coverage Need):',
      headerValue: 99711,
      expandable: false,
    },
  ]

  return <AssetsTable rows={rows} color={'green'} />
}

export default LifeInsuranceTable
